import { STATUS_ICONS, EnumIcon } from '@/lib/icons'

const statusLabels: Record<string, string> = {
  healthy: 'Zdrowa',
  needs_attention: 'Wymaga uwagi',
  sick: 'Chora',
  dormant: 'Uśpiona',
}

interface StatusBadgeProps {
  status: string | null
}

export function StatusBadge({ status }: StatusBadgeProps) {
  if (!status) return null
  const label = statusLabels[status]
  if (!label) return null

  return (
    <span className="inline-flex items-center gap-xs font-label text-xs">
      <EnumIcon entry={STATUS_ICONS[status]} size={14} />
      {label}
    </span>
  )
}
